if (!customElements.get('sticky-atc-bar')) {
  customElements.define(
    'sticky-atc-bar',
    class StickyAtcBar extends HTMLElement {
      connectedCallback() {
        this.container = this.closest('.sticky-atc-bar');
        this.productId = this.dataset.productId;
        this.mainProductInfo = document.querySelector(`product-info[data-product-id="${this.productId}"]`);
        this.variantInput = this.querySelector('[name="id"]');
        this.submitButton = this.querySelector('[type="submit"]');

        document.body.classList.add('sticky-atc-bar-enabled');
        this.updateHeight();
        this.setupObserver();
        this.subscribeToVariantChange();
      }

      setupObserver() {
        const mainBuyButtons = this.mainProductInfo?.querySelector('.product-form__buttons');
        if (!mainBuyButtons) {
          this.container.classList.add('sticky-atc-bar--show');
          return;
        }

        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              this.container.classList.toggle('sticky-atc-bar--show', entry.intersectionRatio < 1);
            });
          },
          { threshold: 1, rootMargin: '-80px 0px 0px 0px' }
        );
        this.observer.observe(mainBuyButtons);
      }

      subscribeToVariantChange() {
        if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

        subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const mainSection = this.mainProductInfo?.dataset.section;
          if (!mainSection || event.data.sectionId !== mainSection) return;

          const variant = event.data.variant;

          this.variantInput.value = variant?.id ?? '';
          this.variantInput.disabled = !variant || !variant.available;

          this.updatePrice(event.data.html);
          this.updateButton(variant);
        });
      }

      updatePrice(html) {
        if (!html) return;
        const mainSection = this.mainProductInfo.dataset.section;
        const sourceContainer = html.getElementById(`price-${mainSection}`);
        const dest = this.querySelector('.sticky-atc-bar__button-price .price');

        if (sourceContainer && dest) {
          const newPrice = sourceContainer.querySelector('.price');
          if (newPrice) dest.outerHTML = newPrice.outerHTML;
        }
      }

      updateButton(variant) {
        const textEl = this.submitButton.querySelector('[data-submit-text]');
        if (!variant || !variant.available) {
          this.submitButton.disabled = true;
          if (textEl) {
            textEl.textContent = !variant
              ? window.variantStrings.unavailable
              : window.variantStrings.soldOut;
          }
        } else {
          this.submitButton.disabled = false;
          if (textEl) textEl.textContent = window.variantStrings.addToCart;
        }
      }

      updateHeight() {
        document.documentElement.style.setProperty(
          '--sticky-atc-bar-height',
          this.container.offsetHeight + 'px'
        );
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        document.body.classList.remove('sticky-atc-bar-enabled');
        document.documentElement.style.removeProperty('--sticky-atc-bar-height');
      }
    }
  );
}
